import {useTranslation} from 'react-i18next'
import {useBoolean} from 'usehooks-ts'

import {IconVendorInfo} from '@sdox/icons'
import {Button} from '@sdox/ui'

import {DealerStampDialog} from './DealerStampDialog/DealerStampDialog'

import type {OpeningHours} from './DealerStampDialog/OpeningHoursTable'

export interface DealerStampProps {
  name: string
  openingHours?: OpeningHours
  address: {
    street: string | null
    zipCode: string | null
    city: string | null
    streetNumber: string | null
  }
  coordinates: {
    lat: string
    long: string
  } | null
  phone: string | null
  email: string | null
  image: {
    url: string
    placeholderUrl: string
    alt: string | null
  } | null
}

export const DealerStamp = (props: DealerStampProps) => {
  const {name} = props
  const {value: isDialogOpen, toggle, setFalse} = useBoolean(false)
  const {t} = useTranslation()

  return (
    <>
      <div className={'@container'}>
        <div
          className={'flex items-center justify-between gap-spacing-20 border-t border-outline-secondary bg-surface-primary pt-spacing-16 @medium:gap-spacing-40'}
        >
          <div className={'flex flex-col text-p2 @medium:flex-row @medium:gap-spacing-8'}>
            <span className={'shrink-0'}>
              {t('common:dealerStamp.yourDealer')}{name ? ':' : null}
            </span>
            <span className={'line-clamp-2 shrink @medium:line-clamp-none @medium:truncate'}>
              {name}
            </span>
          </div>
          <Button
            className={'hidden @medium:flex'}
            size={'medium'}
            variant={'flat'}
            trailing={<IconVendorInfo/>}
            onClick={toggle}
          >
            {t('common:dealerStamp.contact')}
          </Button>
          <Button
            className={'@medium:hidden'}
            size={'small'}
            variant={'flat'}
            trailing={<IconVendorInfo/>}
            onClick={toggle}
          />
        </div>
      </div>
      <DealerStampDialog
        isOpen={isDialogOpen}
        onClose={setFalse}
        {...props}
      />
    </>
  )
}
